import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("IntroPageWidget", {
  title: "Intro Page",
  attributes: {
    headline: {
      title: "Headline",
    },
    hint: {
      title: "Hint message",
      description: "This message will be shown above the button",
    },
    buttonText: {
      title: "Button text",
    },
  },
  properties: ["headline", "hint", "buttonText"],
  initialContent: {
    buttonText: "Weiter",
  },
});
